import { useEffect, useState } from 'react'
import { useFormikContext } from 'formik'

import { getRequestPhase } from '../../../../../../api'
import { EMPTY_OBJECT } from '../../../../../../constants/common'
import { useNotification } from '../../../../../../hooks'
import { TASK_FORM_SERVICE_REQUEST_FIELD_NAME } from '../../../TaskForm.constants'

export function usePhaseFieldLoad({ phases } = EMPTY_OBJECT) {
  const { values } = useFormikContext()

  const { handleAddErrorNotification } = useNotification()

  const serviceRequest = values[TASK_FORM_SERVICE_REQUEST_FIELD_NAME]
  const shouldLoad = Boolean(serviceRequest) && !phases

  const [isLoading, setLoading] = useState(shouldLoad)
  const [items, setItems] = useState(phases || null)
  const [prevValue, setPrevValue] = useState(serviceRequest?.value)

  // Raise the loading flag during render when the selected service request
  // changes; the matching fetch runs in the effect below.
  if (serviceRequest?.value !== prevValue) {
    setPrevValue(serviceRequest?.value)
    setLoading(shouldLoad)
  }

  useEffect(() => {
    if (serviceRequest && !phases) {
      getRequestPhase({ id: serviceRequest.value })
        .then(({ data }) => {
          setItems(data)
        })
        .catch(() => {
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [serviceRequest?.value])

  return {
    isLoading,
    items,
    setItems,
  }
}
